module.exports = __webpack_public_path__ + "img/disabled-semipublic.0ded02cd.png";